import AdsManagerProfitCalculatorPage from "@faire/prototype-playground/workspace/yg/ads-manager-profit-calculator";
import { Route, Switch } from "react-router-dom";

export function YanwuGuRoutes() {
  return (
    <Switch>
      <Route
        path="/yg/ads-manager-profit-calculator"
        component={AdsManagerProfitCalculatorPage}
      />
    </Switch>
  );
}

export const slug = "yg";
